import React, { useState, useEffect, useMemo, forwardRef, useImperativeHandle, useRef } from 'react';
import { FlatList, ScrollView, SectionList, TextInput, TouchableOpacity, View } from 'react-native'

import api from "../../../../../utils/api"
import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';
import { useNavigation, useRoute } from '@react-navigation/native';
import IconButton from '../../../../../components/IconButton';

import Modal from '../../../../../components/Modal';
import useActiveAdminCommunity from '../../../../../hooks/useActiveAdminCommunity';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import Input from '../../../../../components/Forms/Input';


export default function SearchPaymentModal({ onRequestClose, onPaymentFound }){
  const {communityId} = useActiveAdminCommunity()
  const [isSearching, setIsSearching] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const { control, handleSubmit, watch, setValue, reset } = useForm();


  function searchPayment(data){
    const {folio} = data

    setIsSearching(true)
    setErrorMsg(null)

    api.post(`/communities/${communityId}/payments/search`, {folio})
    .then(response => {
      const payment = response.data
      onPaymentFound?.(payment)
    })
    .catch(err => setErrorMsg("Pago no encontrado"))
    .finally(() => setIsSearching(false))
  }

  return (
    <Modal
      onRequestClose={onRequestClose}
      style={{modal: `w-60%`}}
    >
      <Text style={tw`text-lg text-center font-500 mb-3`}>Buscar pago</Text>

      <Input
        control={control}
        name='folio'
        placeholder={'Folio de pago'}
        rules={{ required: true }}
      />

      {
        errorMsg &&
          <Text style={tw`text-red py-3 text-center`}>{errorMsg}</Text>
      }

      <IconButton
        title={isSearching ? "Buscando..." : "Buscar"}
        style={tw`self-end mt-3`}
        icon='search'
        disabled={isSearching}
        onPress={handleSubmit(searchPayment)}
      />
    </Modal>
  )
}